<template>
  <div>
    <h2 class="subheading font-weight-bold mt-2">
      Метки
    </h2>
    <v-list
      :style="{ 'overflow-y': 'auto', height: blockLabelsHeight + 'px' }"
      class="pt-0"
    >
      <v-list-tile
        v-for="(label, index) in values"
        :key="index"
        class="compact"
      >
        <v-list-tile-content class="label-title pr-1">
          {{ labels[label.name].title }}
        </v-list-tile-content>
        <v-tooltip
          v-if="labels[label.name].disabled && labels[label.name].tooltip"
          top
        >
          <template v-slot:activator="{ on }">
            <v-list-tile-action
              v-if="!labels[label.name].group"
              v-on="on"
            >
              <v-layout
                justify-end
                align-center
              >
                <span class="caption grey--text text--lighten-1 label-author">{{
                  label.author | shortName
                }}</span>
                <v-menu
                  v-if="labels[label.name].variants"
                  :disabled="!canEdit || labels[label.name].disabled"
                  menu-props="offsetY"
                >
                  <template v-slot:activator="{ on }">
                    <v-chip
                      text-color="white"
                      label
                      small
                      :color="getColor(label)"
                      v-on="!user.hasEmployee ? null : on"
                      @click="
                        !user.hasEmployee
                          ? showInfo('Пользователь не привязан к сотруднику')
                          : false
                      "
                    >
                      {{ getVariantTitle(label) }}
                    </v-chip>
                  </template>
                  <v-list>
                    <v-list-tile
                      v-for="(variant, index) in getAvailableVariants(label)"
                      :key="index"
                      @click="
                        changeLabel({ newValue: variant.id, label: label })
                      "
                    >
                      <v-list-tile-title>
                        {{ variant.description || variant.title }}
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-layout>
            </v-list-tile-action>
          </template>
          <span>{{ labels[label.name].tooltip }}</span>
        </v-tooltip>
        <v-list-tile-action v-else-if="!labels[label.name].group">
          <v-layout
            justify-end
            align-center
          >
            <span class="caption grey--text text--lighten-1 label-author">{{
              label.author | shortName
            }}</span>
            <v-menu
              v-if="labels[label.name].variants"
              :disabled="!canEdit || labels[label.name].disabled"
              menu-props="offsetY"
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  text-color="white"
                  label
                  small
                  :color="getColor(label)"
                  v-on="!user.hasEmployee ? null : on"
                  @click="
                    !user.hasEmployee
                      ? showInfo('Пользователь не привязан к сотруднику')
                      : false
                  "
                >
                  {{ getVariantTitle(label) }}
                </v-chip>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(variant, index) in getAvailableVariants(label)"
                  :key="index"
                  @click="changeLabel({ newValue: variant.id, label: label })"
                >
                  <v-list-tile-title>
                    {{ variant.description || variant.title }}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-layout>
        </v-list-tile-action>
        <v-list-tile-action v-else>
          <combined-label
            v-if="labels"
            :label="label"
            :can-edit="!canEdit || labels[label.name].disabled"
            :user="user"
            @changeLabel="changeLabel"
          />
        </v-list-tile-action>
      </v-list-tile>
      <v-layout align-center>
        <v-flex>
          <span class="body-1 px-1">{{ packagesLabel.name }}</span>
        </v-flex>
        <v-spacer />
        <v-flex>
          <ColorsLabel
            :labels="packagesLabel.values"
            :author="packagesLabel.author"
          />
        </v-flex>
      </v-layout>
    </v-list>
  </div>
</template>

<script>
import CombinedLabel from "./CombinedLabel.vue";
import ColorsLabel from "../../../../components/label/ColorsLabel.vue";
import lables from "./lables.js";
import { changeShippingLabel } from "../../../../backend/shippingsApi.js";
import auth from "../../../../auth.js";
import _ from "lodash";

export default {
  components: {
    CombinedLabel,
    ColorsLabel,
  },
  props: ["id", "values", "blockHeight", "canEdit"],
  data() {
    return {
      labels: lables,
      user: null,
    };
  },
  computed: {
    blockLabelsHeight() {
      return this.blockHeight - 48;
    },
    isNonStandartExist() {
      return this.$store.getters["shipping/isNonStandartExist"];
    },
    goodsDetails() {
      return this.$store.getters["shipping/goodsDetails"];
    },
    packages() {
      return this.$store.getters["shipping/packages"];
    },
    packagesLabel() {
      const groupedPackages = _.groupBy(
        this.packages.value,
        p => p.packageTypeId,
      );
      const packageItems = [];
      for (const key in groupedPackages) {
        const groupe = groupedPackages[key][0];
        const packageItem = {
          title: groupe.title,
          shortTitle: groupe.shortTitle,
          color: groupe.color,
          tooltip: true,
        };
        packageItems.push(packageItem);
      }
      return {
        name: "Тип упаковки",
        author: this.packages.author,
        values: packageItems,
      };
    },
  },
  watch: {
    values: {
      handler() {
        this.values.forEach(element => {
          if (element.group) {
            element.value.forEach(item => {
              if (typeof item.value === "boolean") {
                item.value
                  ? (this.labels[element.name].value[item.name].value = 1)
                  : (this.labels[element.name].value[item.name].value = 0);
              }
              if (typeof item.value === "number") {
                this.labels[element.name].value[item.name].value = item.value;
              }
              if (Object.prototype.hasOwnProperty.call(item, "disabled")) {
                this.labels[element.name].value[item.name].disabled =
                  item.disabled;
                this.labels[element.name].value[item.name].tooltip =
                  item.tooltip;
              }
            });
          } else {
            if (typeof element.value === "boolean") {
              element.value
                ? (this.labels[element.name].value = 1)
                : (this.labels[element.name].value = 0);
            }
            if (typeof element.value === "number") {
              this.labels[element.name].value = element.value;
            }
            if (Object.prototype.hasOwnProperty.call(element, "disabled")) {
              this.labels[element.name].disabled = element.disabled;
              this.labels[element.name].tooltip = element.tooltip;
            }
          }
        });
      },
      deep: true,
    },
    isNonStandartExist() {
      if (this.isNonStandartExist) {
        this.labels["multimodal"].value = 1;
        this.labels["multimodal"].disabled = true;
      } else {
        this.labels["multimodal"].disabled = false;
      }
    },
    goodsDetails: {
      handler() {
        if (
          this.goodsDetails.find(i => i.fragile) &&
          this.labels.fragile.disabled
        ) {
          return;
        } else if (
          this.goodsDetails.find(i => i.fragile) &&
          !this.labels.fragile.disabled
        ) {
          this.labels.fragile.disabled = !this.labels.fragile.disabled;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.user = auth.getUser();
  },
  methods: {
    async changeLabel(labelInfo) {
      if (!this.canEdit) {
        this.showError(
          "Поставка в статусе 'Завершена'. Изменения не возможны.",
        );
        return;
      }
      if (labelInfo.groupName) {
        this.labels[labelInfo.groupName].value[labelInfo.label.name].value =
          labelInfo.newValue;
      } else {
        this.labels[labelInfo.label.name].value = labelInfo.newValue;
      }
      let value = labelInfo.newValue;
      if (typeof labelInfo.label.value === "boolean") {
        labelInfo.newValue === 0 ? (value = false) : (value = true);
      }
      const result = await changeShippingLabel(
        this.id,
        labelInfo.label.name,
        value,
      );
      this.$emit("change", {
        name: labelInfo.label.name,
        value,
        groupName: labelInfo.groupName,
        author: result,
      });
    },
    getColor(labelValue) {
      const defaultColor = "grey";
      const currentVariant = this.labels[labelValue.name].variants.find(
        v => v.id === this.labels[labelValue.name].value,
      );
      if (currentVariant && currentVariant.color) {
        return currentVariant.color;
      } else {
        return defaultColor;
      }
    },
    getVariantTitle(labelValue) {
      return this.labels[labelValue.name].variants.find(
        v => v.id === this.labels[labelValue.name].value,
      ).title;
    },
    getAvailableVariants(labelValue) {
      return this.labels[labelValue.name].variants.filter(
        v => v.id !== this.labels[labelValue.name].value,
      );
    },
  },
};
</script>

<style>
.compact .v-list__tile {
  padding-left: 4px;
  padding-right: 0px;
}
.v-list__tile__content.label-title {
  white-space: nowrap;
  overflow: unset;
}
.compact .v-chip.v-chip--label.v-chip--small {
  margin: 4px 0 2px 4px;
}
.label-author {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
